<template>
  <div :class="isLarge ? 'col-lg-12' : 'col-lg-4'" class="dashboard-card-col">
    <div class="card dashboard-card-frame h-100">
      <div
        class="card-header dashboard-card-header d-flex justify-content-between align-items-center"
      >
        <h5 class="dashboard-card-title">
          <i :class="icon"></i>
          <span>{{ title }}</span>
        </h5>
        <div v-if="withControls">
          <button
            class="btn btn-sm btn-outline-secondary me-2"
            @click="$emit('refresh')"
            :disabled="isLoading"
          >
            <i
              :class="[
                'bi bi-arrow-clockwise',
                { 'spinner-border spinner-border-sm': isLoading },
              ]"
            ></i>
          </button>
          <button
            class="btn btn-sm btn-outline-secondary"
            @click="$store.dispatch('cards/toggleCard', section)"
          >
            <i
              :class="
                $store.getters['cards/isCardCollapsed'](section)
                  ? 'bi bi-chevron-down'
                  : 'bi bi-chevron-up'
              "
            ></i>
          </button>
        </div>
      </div>
      <div
        :class="{ collapse: $store.getters['cards/isCardCollapsed'](section) && withControls }"
      >
        <div :class="fullHeight ? 'dashboard-card-body' : 'card-body dashboard-card-body dashboard-card-scroll'">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    section: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isLarge: {
      type: Boolean,
      default: false,
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
    withControls: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getBorderClass(value, limits, reverse) {
      if (value <= limits[0])
        return reverse ? "border-left-red" : "border-left-green";
      if (value > limits[0] && value < limits[1]) return "border-left-yellow";
      return reverse ? "border-left-green" : "border-left-red";
    },
    getBadgeClass(value, limits) {
      if (value <= limits[0]) return "bg-danger";
      if (value > limits[0] && value < limits[1]) return "bg-warning";
      return "bg-light text-dark";
    },
  },
};
</script>
<style scoped>
.dashboard-card-col {
  display: flex;
  margin-bottom: 1rem;
}

.dashboard-card-frame {
  width: 100%;
  border: 0;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08);
}

.dashboard-card-header {
  padding: 0.55rem 0.75rem;
  background: #f8f9fa;
}

.dashboard-card-title {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  line-height: 1.2;
}

.dashboard-card-body {
  padding: 0.75rem;
}

.dashboard-card-scroll {
  max-height: 500px;
  overflow-y: auto;
}
.card-header i {
  color: #6c757d !important;
}
.spinner-border {
  margin: 0px;
}
.spinner-border-xs {
  border-width: 0px;
}
.btn:hover i {
  color: #d1d1d1 !important;
}
.badge {
  font-size: 0.85rem;
  padding: 0.4em 0.75em;
}
.tab-title {
  position: relative;
  top: 5px;
}
</style>  
